import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BeeHeardWidget = () => {
  const location = useLocation();

  function waitForElement(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      return null;
    });
  }

  useEffect(() => {
    const beeHeardButtonId = '#beeheard-buttons-con';
    waitForElement(beeHeardButtonId).then(element => {
      // Show BeeHeard widget only on Homepage
      if (location.pathname === '/') {
        element.style.display = 'flex';
      } else {
        element.style.display = 'none';
      }
    });
  }, [location]);

  return null;
};

export default BeeHeardWidget;
